'use client';

import type { FC } from 'react';
import { useTopAnnouncement } from './use-top-announcement';

export const TopAnnouncementBar: FC<{ className?: string }> = ({ className }) => {
  const { activeAnnouncement, closeAnnouncement } = useTopAnnouncement();

  if (!activeAnnouncement) return null;

  const Component = activeAnnouncement.component;
  return <Component className={className} onClose={() => closeAnnouncement(activeAnnouncement.id)} />;
};
